/* ============================================================
   Bastukronan — Configurator engine
   Renders a BMW-style stepped builder from JSON, keeps a live
   price total, swaps the hero image, and adds the base product
   plus each paid add-on to the cart as separate line items.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.cfgReady) return;
    root.dataset.cfgReady = '1';

    var $ = function (sel) { return root.querySelector(sel); };
    var sectionId = root.dataset.sectionId;

    var config      = readJSON('[data-cfg-config]');
    var baseVariants = readJSON('[data-cfg-base-variants]') || [];
    var addonMap    = readJSON('[data-cfg-addons]') || {}; /* optional inline seed */
    /* photos uploaded via "Option photo" blocks in the theme editor,
       keyed by lowercased option label / id / SKU */
    var optionImages = readJSON('[data-cfg-option-images]') || {};

    function optPhoto(opt) {
      if (!opt) return null;
      var keys = [opt.label, opt.id, opt.sku], i, hit;
      for (i = 0; i < keys.length; i++) {
        if (!keys[i]) continue;
        hit = optionImages[String(keys[i]).trim().toLowerCase()];
        if (hit && hit.bubble) return hit;
      }
      return null;
    }

    /* "asset:foo.png" in configurator JSON -> this theme's asset URL */
    var assetBase = root.dataset.assetBase || '';
    function resolveAsset(src) {
      if (src && String(src).indexOf('asset:') === 0) return assetBase + String(src).slice(6);
      return src;
    }

    /* tolerate a metafield delivered as a JSON *string* (double-encoded) */
    if (typeof config === 'string') {
      try { config = JSON.parse(config); } catch (e) { config = null; }
    }
    /* always fall back to a usable config so the panel is never blank */
    if (!config || !config.steps || !config.steps.length) { config = buildDemoConfig(); }

    /* Fetch the add-on SKU -> variantId map from the collection JSON (≤250),
       avoiding Liquid's 50-product cap. Resolves before the user can check out. */
    var addonHandle = root.dataset.addonCollection;
    if (addonHandle) {
      fetch('/collections/' + addonHandle + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.products) return;
          data.products.forEach(function (p) {
            var img = (p.images && p.images[0] && p.images[0].src) || null;
            (p.variants || []).forEach(function (v) {
              if (v.sku) addonMap[v.sku] = { id: v.id, price: Math.round(parseFloat(v.price) * 100), title: p.title, image: img };
            });
          });
          fillBubblesFromProducts();
        })
        .catch(function () {});
    }

    /* Options whose bubble is empty (no editor upload, missing/broken swatch)
       borrow the photo of the product their SKU points at. */
    function fillBubblesFromProducts() {
      Array.prototype.forEach.call(stepsEl.querySelectorAll('.bastuk-cfg__opt[data-sku]'), function (el) {
        if (el.dataset.editorPhoto === '1') return;             /* editor upload wins */
        var addon = addonMap[el.dataset.sku];
        if (!addon || !addon.image) return;
        var url = addon.image + (addon.image.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
        var sw = el.querySelector('.bastuk-cfg__opt-swatch');
        function apply() {
          sw.classList.add('bastuk-cfg__opt-swatch--photo');
          sw.style.backgroundColor = '';
          sw.style.backgroundImage = 'url(' + url + ')';
        }
        if (!sw) {
          sw = document.createElement('span');
          sw.className = 'bastuk-cfg__opt-swatch';
          el.insertBefore(sw, el.querySelector('.bastuk-cfg__opt-body'));
          apply();
          return;
        }
        if (sw.style.backgroundColor) return;                    /* keep colour swatches */
        var cur = (sw.style.backgroundImage.match(/url\(["']?(.*?)["']?\)/) || [])[1];
        if (!cur) { apply(); return; }
        var probe = new Image();                                 /* replace only broken images */
        probe.onerror = apply;
        probe.src = cur;
      });
    }

    /* ---------- currency / multi-market display ----------
       Configurator prices live in the base currency (EUR). Each market shows its
       own currency: the active presentment currency comes from cart.currency.iso_code;
       a merchant-set rate table converts the base numbers for display. The cart still
       charges the real products, which Shopify converts per market at checkout. */
    var baseCur = (root.dataset.baseCurrency || 'SEK').toUpperCase();
    var activeCur = (root.dataset.currency || baseCur).toUpperCase();
    var rates = {};
    (root.dataset.currencyRates || '').split(',').forEach(function (pair) {
      var kv = pair.split(':');
      var code = (kv[0] || '').trim().toUpperCase();
      var r = parseFloat(kv[1]);
      if (code && !isNaN(r)) rates[code] = r;
    });
    var dispCur, rate;
    if (activeCur === baseCur) { dispCur = baseCur; rate = 1; }
    else if (rates[activeCur]) { dispCur = activeCur; rate = rates[activeCur]; }
    else { dispCur = baseCur; rate = 1; } /* no rate set → show base, never a wrong symbol */
    /* Format exactly like Shopify's `money` filter does everywhere else on the
       site. Intl.NumberFormat with an undefined locale follows the *browser's*
       language, so an English-language browser in Sweden rendered "SEK 60,000"
       in the configurator next to "60 000,00 kr" on every product card. The
       shop's own money format string is authoritative, so parse that instead
       and only fall back to Intl when it is unavailable. */
    var moneyFormat = root.dataset.moneyFormat || '';

    function groupNumber(amount, thousands, decimalSep, decimals) {
      var parts = Math.abs(amount).toFixed(decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var out = (amount < 0 ? '-' : '') + whole;
      if (decimals > 0) out += decimalSep + parts[1];
      return out;
    }

    function renderMoneyFormat(amount) {
      /* Shopify placeholders: amount (1,134.65), amount_no_decimals (1,135),
         amount_with_comma_separator (1.134,65), amount_no_decimals_with_comma_separator
         (1.135), amount_with_space_separator (1 134,65),
         amount_no_decimals_with_space_separator (1 135), amount_with_apostrophe_separator. */
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
        switch (name) {
          case 'amount': return groupNumber(amount, ',', '.', 2);
          case 'amount_no_decimals': return groupNumber(amount, ',', '.', 0);
          case 'amount_with_comma_separator': return groupNumber(amount, '.', ',', 2);
          case 'amount_no_decimals_with_comma_separator': return groupNumber(amount, '.', ',', 0);
          case 'amount_with_space_separator': return groupNumber(amount, ' ', ',', 2);
          case 'amount_no_decimals_with_space_separator': return groupNumber(amount, ' ', ',', 0);
          case 'amount_with_apostrophe_separator': return groupNumber(amount, "'", '.', 2);
          default: return groupNumber(amount, ',', '.', 0);
        }
      });
    }

    var intlFmt = null;
    try {
      /* Locale comes from the page, never from the browser, so both storefront
         languages format the same way. */
      var pageLocale = (document.documentElement.lang || 'sv').toLowerCase() === 'en' ? 'en-GB' : 'sv-SE';
      intlFmt = new Intl.NumberFormat(pageLocale, {
        style: 'currency', currency: dispCur, maximumFractionDigits: 0
      });
    } catch (e) { intlFmt = null; }

    var useShopFormat = moneyFormat.indexOf('{{') !== -1 && dispCur === baseCur;

    function money(v) {
      var amount = Math.round((+v || 0) * rate);
      if (useShopFormat) return renderMoneyFormat(amount);
      if (intlFmt) return intlFmt.format(amount);
      return amount + ' ' + dispCur;
    }
    var fmt = { format: money }; /* back-compat alias */

    /* ---------- live 3D model (barrel saunas) ---------- */
    var modelEl = root.querySelector('[data-cfg-model]');
    var modelActive = !!(modelEl && config && config.model3d && root.dataset.modelUrl);
    var claddingMats = [];

    function setupModel() {
      if (heroEl) heroEl.style.display = 'none';
      var ph = root.querySelector('[data-cfg-hero-placeholder]');
      if (ph) ph.style.display = 'none';
      modelEl.hidden = false;
      var hint = root.querySelector('[data-cfg-model-hint]');
      if (hint) hint.hidden = false;
      modelEl.addEventListener('pointerdown', function () { if (hint) hint.style.opacity = '0'; });

      whenModelReady(function () {
        collectCladding();
        applyCurrentTint();
        if (root.dataset.modelAutorotate === 'true' &&
            !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          modelEl.setAttribute('auto-rotate', '');
          modelEl.setAttribute('auto-rotate-delay', '2500');
          modelEl.setAttribute('rotation-per-second', '14deg');
        }
      });
    }
    function modelReady() {
      return !!(modelEl.model && modelEl.model.materials && modelEl.model.materials.length);
    }
    function whenModelReady(cb) {
      if (modelReady()) { cb(); return; }
      var done = false;
      var run = function () { if (done || !modelReady()) return; done = true; cb(); };
      modelEl.addEventListener('load', run);
      /* fallback poll — covers the case where 'load' fired before this listener
         attached (e.g. a cached GLB) */
      var tries = 0;
      var iv = setInterval(function () {
        if (done || tries++ > 60) { clearInterval(iv); return; }
        if (modelReady()) { clearInterval(iv); run(); }
      }, 200);
    }
    function collectCladding() {
      claddingMats = [];
      try {
        var mats = (modelEl.model && modelEl.model.materials) || [];
        var names = (root.dataset.modelCladding || '').toLowerCase()
          .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        /* auto-detect targets the EXTERIOR cladding only, so interior benches
           (alder/"lepp", cherry) and plywood keep their natural wood. */
        var inc = /wood|plank|clad|barrel|board|spruce|larch|pine|timber|stav|panel|body/;
        var exc = /bench|seat|floor|ceil|lepp|cherry|alder|plywood|interior|inside|sindel|shingle|stone|glass|metal|harvia/;
        mats.forEach(function (m) {
          var nm = (m.name || '').toLowerCase();
          var match = names.length
            ? names.some(function (n) { return nm.indexOf(n) >= 0; })   /* explicit list is authoritative */
            : (inc.test(nm) && !exc.test(nm));
          if (match) claddingMats.push(m);
        });
      } catch (e) {}
    }
    function hexFactor(hex) {
      hex = String(hex || '').replace('#', '');
      if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1');
      var r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
      if (isNaN(r) || isNaN(g) || isNaN(b)) return null;
      return [r / 255, g / 255, b / 255, 1];
    }
    function tintCladding(hex) {
      if (!modelActive) return;
      var f = hexFactor(hex);
      if (!f) return;
      if (!claddingMats.length && modelReady()) collectCladding(); /* lazy collect */
      claddingMats.forEach(function (m) {
        try { m.pbrMetallicRoughness.setBaseColorFactor(f); } catch (e) {}
      });
    }
    /* named swatches: colour names used in configurator JSON -> hex.
       Lets options say "swatch": "teak" (or just have a matching label)
       instead of a hex code. */
    var SWATCH_NAMES = {
      natural: '#c9ab7e', clear: '#d8c49a', colourless: '#d8c49a', colorless: '#d8c49a',
      teak: '#b07a3c', brown: '#6f4a2a', grey: '#8d8a85', gray: '#8d8a85',
      spruce: '#caa472', thermo: '#5a3a1d', pine: '#d3b184', oak: '#a8834f',
      walnut: '#5c4030', honey: '#c98d3f', black: '#26221e', ebony: '#241d18',
      white: '#e9e4d8', green: '#3f5a3c', anthracite: '#3a3d40', red: '#7a2f23', blue: '#2f4a6b'
    };
    function swatchColor(opt, step) {
      if (!opt) return null;
      if (opt.swatch && /^(#|rgb|hsl)/i.test(opt.swatch)) return opt.swatch;
      /* Only guess a colour from the option's id/label text for steps that are
         actually about material/finish. Guessing on every step (heater, control,
         windows, ...) produces false positives, e.g. "Termometer" containing
         "thermo", or "UKU Local Black 18 kW" containing the word "black". */
      if (step && !/^(wood|finish|paint|colou?r)$/i.test(step.id)) return null;
      var key = ((opt.swatch || '') + ' ' + (opt.id || '') + ' ' + (opt.label || '')).toLowerCase();
      for (var name in SWATCH_NAMES) {
        if (new RegExp('\\b' + name + '\\b').test(key)) return SWATCH_NAMES[name];
      }
      return null;
    }
    function applyCurrentTint() {
      var order = ['finish', 'paint', 'colour', 'color', 'wood'], i, s, col;
      for (i = 0; i < order.length; i++) {
        s = state[order[i]];
        col = s && s.option ? swatchColor(s.option, { id: order[i] }) : null;
        if (col) { tintCladding(col); return; }
      }
    }

    var stepsEl = $('[data-cfg-steps]');
    var totalEl = $('[data-cfg-total]');
    var specEl  = $('[data-cfg-spec]');
    var specEls = root.querySelectorAll('[data-cfg-spec], [data-cfg-spec-mobile]');
    var heroEl  = $('[data-cfg-hero]');
    var visualEl = $('[data-cfg-visual]');
    var addBtn  = $('[data-cfg-add]');
    var addLabel = $('[data-cfg-add-label]');
    var quoteBtn = $('[data-cfg-quote]');

    /* selection state: stepId -> { optionId, option }  (or array for multi) */
    var state = {};

    function readJSON(sel) {
      var node = root.querySelector(sel);
      if (!node) return null;
      try { return JSON.parse(node.textContent.trim()); } catch (e) { return null; }
    }

    /* ---------- base variant resolution ---------- */
    /* The first step of type "variant" maps option ids to Shopify variants
       (e.g. wood = Spruce/Thermowood). Its price IS the base product price. */
    function baseVariantStep() {
      return (config.steps || []).filter(function (s) { return s.type === 'variant'; })[0];
    }
    function resolveVariantId() {
      var vs = baseVariantStep();
      if (!vs) return baseVariants[0] ? baseVariants[0].id : null;
      var sel = state[vs.id];
      if (sel && sel.option && sel.option.variant) return sel.option.variant;
      /* match by title against rendered variants */
      if (sel && sel.option) {
        var match = baseVariants.filter(function (v) {
          return (v.option1 || '').toLowerCase() === String(sel.option.label).toLowerCase()
              || (v.title || '').toLowerCase() === String(sel.option.label).toLowerCase();
        })[0];
        if (match) return match.id;
      }
      return baseVariants[0] ? baseVariants[0].id : null;
    }
    function baseVariantPrice() {
      /* use the metafield (base-currency) number so the whole total stays in one
         currency and converts uniformly; the cart still charges the real variant */
      var vs = baseVariantStep();
      var sel = vs && state[vs.id];
      if (sel && sel.option && typeof sel.option.price === 'number') return sel.option.price;
      if (config.base_price) return config.base_price;
      var id = resolveVariantId();
      var v = baseVariants.filter(function (x) { return x.id === id; })[0];
      return v ? v.price / 100 : 0;
    }

    /* ---------- rendering ---------- */
    function render() {
      stepsEl.innerHTML = '';
      (config.steps || []).forEach(function (step, i) {
        stepsEl.appendChild(renderStep(step, i));
      });
      recalc();
    }

    function renderStep(step, index) {
      var multi = step.type === 'multi';
      var wrap = document.createElement('div');
      wrap.className = 'bastuk-cfg__step' + (multi ? ' bastuk-cfg__step--multi' : '');
      wrap.dataset.step = step.id;

      var modeLabel = multi
        ? (root.dataset.tChooseAny || 'Välj ett eller flera alternativ')
        : (root.dataset.tChooseOne || 'Välj ett alternativ');

      var head = document.createElement('div');
      head.className = 'bastuk-cfg__step-head';
      head.innerHTML =
        '<div>' +
          '<span class="bastuk-cfg__step-num' + (multi ? ' is-multi' : '') + '">' +
            (multi ? '<svg class="bastuk-cfg__multi-ico" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6.5l2.5 2.5L10 3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '') +
            esc(modeLabel) +
          '</span>' +
          '<h3 class="bastuk-cfg__step-title">' + esc(step.label) + '</h3>' +
        '</div>' +
        '<span class="bastuk-cfg__step-chosen" data-chosen></span>';
      wrap.appendChild(head);

      if (step.help) {
        var help = document.createElement('p');
        help.className = 'bastuk-cfg__step-help';
        help.textContent = step.help;
        wrap.appendChild(help);
      }

      var opts = document.createElement('div');
      opts.className = 'bastuk-cfg__opts' + (step.layout === 'grid' ? ' bastuk-cfg__opts--cols' : '');
      var list = step.options || [];
      if (multi) list = [{ id: '__none__', label: (root.dataset.tNone || 'Inget'), price: 0, __none: true }].concat(list);
      list.forEach(function (opt) {
        opts.appendChild(renderOption(step, opt, multi));
      });

      /* Keep a step visually even: if some options in it got a swatch or photo
         and others did not, the rows sat at different indents. Give the rest a
         muted placeholder bubble so the column lines up. */
      var rendered = opts.querySelectorAll('.bastuk-cfg__opt');
      var withSwatch = opts.querySelectorAll('.bastuk-cfg__opt-swatch').length;
      if (withSwatch > 0 && withSwatch < rendered.length) {
        Array.prototype.forEach.call(rendered, function (label) {
          if (label.querySelector('.bastuk-cfg__opt-swatch')) return;
          var ph = document.createElement('span');
          ph.className = 'bastuk-cfg__opt-swatch bastuk-cfg__opt-swatch--blank';
          label.insertBefore(ph, label.children[1] || null);
        });
      }

      wrap.appendChild(opts);
      return wrap;
    }

    function renderOption(step, opt, multi) {
      var label = document.createElement('label');
      label.className = 'bastuk-cfg__opt';
      label.dataset.opt = opt.id;

      var price = +opt.price || 0;
      /* A "variant" step's price is the model's own base price, not a surcharge,
         so it must not be prefixed with "+" — that read as an extra 60 000 kr
         on top of a sauna that already costs 60 000 kr. */
      var isBaseStep = step.type === 'variant';
      var priceHtml = opt.__none
        ? ''
        : (price > 0
          ? '<span class="bastuk-cfg__opt-price">' + (isBaseStep ? '' : '+ ') + fmt.format(price) + '</span>'
          : '<span class="bastuk-cfg__opt-price bastuk-cfg__opt-price--free">' + (isBaseStep ? '' : (root.dataset.tIncluded || 'Ingår')) + '</span>');

      var swatch = '';
      var swCol = swatchColor(opt, step);
      var photo = optPhoto(opt);
      if (photo) {
        /* theme-editor upload wins over anything in the JSON */
        swatch = '<span class="bastuk-cfg__opt-swatch bastuk-cfg__opt-swatch--photo' +
          (photo.fit === 'contain' ? ' bastuk-cfg__opt-swatch--contain' : '') +
          '" style="background-image:url(' + photo.bubble + ')"></span>';
      } else if (opt.swatch && /\/|\.(png|jpe?g|webp|gif|svg)/i.test(opt.swatch)) {
        /* image URL swatch (supports asset: refs from the configurator JSON) */
        swatch = '<span class="bastuk-cfg__opt-swatch bastuk-cfg__opt-swatch--photo" style="background-image:url(' + resolveAsset(opt.swatch) + ')"></span>';
      } else if (swCol) {
        /* hex/rgb swatch, or a colour name resolved via SWATCH_NAMES */
        swatch = '<span class="bastuk-cfg__opt-swatch" style="background:' + swCol + '"></span>';
      } else if (opt.swatch) {
        /* last resort: hand the raw value to CSS (e.g. a valid CSS colour name) */
        swatch = '<span class="bastuk-cfg__opt-swatch" style="background:' + opt.swatch + '"></span>';
      }

      if (opt.sku) label.dataset.sku = opt.sku;
      if (photo) label.dataset.editorPhoto = '1';

      label.innerHTML =
        '<input type="' + (multi ? 'checkbox' : 'radio') + '" name="cfg-' + step.id + '" value="' + esc(opt.id) + '">' +
        swatch +
        '<span class="bastuk-cfg__opt-body">' +
          '<span class="bastuk-cfg__opt-name">' + esc(opt.label) + '</span>' +
          (opt.desc ? '<span class="bastuk-cfg__opt-desc">' + esc(opt.desc) + '</span>' : '') +
        '</span>' +
        priceHtml +
        '<span class="bastuk-cfg__opt-check"></span>';

      label.addEventListener('click', function (e) {
        e.preventDefault();
        if (fx && fxCanvas) {
          var r = fxCanvas.getBoundingClientRect();
          fx.burst(e.clientX - r.left, e.clientY - r.top);
        }
        select(step, opt, multi, label);
      });
      return label;
    }

    function select(step, opt, multi, labelEl) {
      var group = labelEl.parentElement;
      if (multi) {
        if (opt.__none) {
          /* exclusive "None": clear all real picks */
          Array.prototype.forEach.call(group.querySelectorAll('.bastuk-cfg__opt'), function (el) {
            el.classList.remove('is-selected');
          });
          labelEl.classList.add('is-selected');
          state[step.id] = { multi: true, options: [] };
        } else {
          var noneEl = group.querySelector('[data-opt="__none__"]');
          if (noneEl) noneEl.classList.remove('is-selected');
          labelEl.classList.toggle('is-selected');
          var arr = (state[step.id] && state[step.id].options) || [];
          if (labelEl.classList.contains('is-selected')) {
            arr.push(opt);
          } else {
            arr = arr.filter(function (o) { return o.id !== opt.id; });
          }
          if (arr.length === 0 && noneEl) noneEl.classList.add('is-selected'); /* fall back to None */
          state[step.id] = { multi: true, options: arr };
        }
      } else {
        Array.prototype.forEach.call(group.querySelectorAll('.bastuk-cfg__opt'), function (el) {
          el.classList.remove('is-selected');
        });
        labelEl.classList.add('is-selected');
        state[step.id] = { optionId: opt.id, option: opt };
        var selPhoto = optPhoto(opt);
        var bigImg = (selPhoto && selPhoto.large) || opt.image;
        if (bigImg) swapHero(bigImg);
        var tintCol = swatchColor(opt, step);
        if (modelActive && /wood|finish|paint|colou?r/i.test(step.id) && tintCol) {
          tintCladding(tintCol);
        }
      }
        recalc();
      var lastIndex = (config.steps || []).length - 1;
      if (!multi && currentStep < lastIndex) {
        setTimeout(advance, 320); /* advance to next step, no scroll */
      }
}
    /* preselect: defaults for single steps; "None" for multi steps */
    function preselect() {
      (config.steps || []).forEach(function (step) {
        if (step.type === 'multi') {
          state[step.id] = { multi: true, options: [] };
          var noneEl = stepsEl.querySelector('[data-step="' + step.id + '"] [data-opt="__none__"]');
          if (noneEl) noneEl.classList.add('is-selected');
          return;
        }
        var def = (step.options || []).filter(function (o) { return o.default; })[0]
               || ((step.type === 'variant' || step.required) ? step.options[0] : null);
        if (def) {
          state[step.id] = { optionId: def.id, option: def };
          var el = stepsEl.querySelector('[data-step="' + step.id + '"] [data-opt="' + cssEsc(def.id) + '"]');
          if (el) el.classList.add('is-selected');
          var defPhoto = optPhoto(def);
          var defImg = (defPhoto && defPhoto.large) || def.image;
          if (defImg) swapHero(defImg, true);
        }
      });
    }

    /* ---------- price + spec ---------- */
    function recalc() {
      var total = baseVariantPrice();
      var specs = [];
      var vs = baseVariantStep();

      (config.steps || []).forEach(function (step) {
        var sel = state[step.id];
        if (!sel) { markChosen(step, '—'); return; }

        if (sel.multi) {
          if (!sel.options.length) { markChosen(step, root.dataset.tNone || 'Inget'); return; }
          var names = [];
          sel.options.forEach(function (o) {
            total += (+o.price || 0) * (o.qty || 1);
            names.push(o.label + (o.qty > 1 ? ' ×' + o.qty : ''));
          });
          markChosen(step, names.join(', '));
          specs.push({ k: step.label, v: names.join(', ') });
        } else {
          var o = sel.option;
          /* the variant step's price is already in the base price */
          if (step !== vs) total += (+o.price || 0);
          markChosen(step, o.label + (o.price > 0 ? ' · ' + (step === vs ? '' : '+') + fmt.format(o.price) : ''));
          specs.push({ k: step.label, v: o.label });
        }
      });

      totalEl.textContent = fmt.format(Math.round(total));
      renderChips();
      validate();
    }

    function markChosen(step, text) {
      var el = stepsEl.querySelector('[data-step="' + step.id + '"] [data-chosen]');
      if (el) el.textContent = text;
    }

    /* ---------- wizard: one step at a time ---------- */
    var currentStep = 0, maxStep = 0, navEl = null;

    function stepEls() { return stepsEl.querySelectorAll('.bastuk-cfg__step'); }

    var T = {
      back: root.dataset.tBack || 'Tillbaka',
      next: root.dataset.tNext || 'Nästa',
      review: root.dataset.tReview || 'Sammanfattning',
      progress: root.dataset.tProgress || 'Steg [current] av [total]'
    };

    function buildNav() {
      /* re-init (theme editor) must never stack duplicate nav bars */
      Array.prototype.forEach.call(root.querySelectorAll('.bastuk-cfg__nav'), function (n) {
        n.parentNode.removeChild(n);
      });
      navEl = document.createElement('div');
      navEl.className = 'bastuk-cfg__nav';
      navEl.innerHTML =
        '<button type="button" class="bastuk-cfg__nav-btn" data-back>&larr; ' + esc(T.back) + '</button>' +
        '<span class="bastuk-cfg__nav-progress" data-progress></span>' +
        '<button type="button" class="bastuk-cfg__nav-btn bastuk-cfg__nav-btn--next" data-next>' + esc(T.next) + ' &rarr;</button>';
      stepsEl.parentNode.insertBefore(navEl, stepsEl.nextSibling);
      navEl.querySelector('[data-back]').addEventListener('click', function () { showStep(currentStep - 1); });
      navEl.querySelector('[data-next]').addEventListener('click', function () {
        var n = (config.steps || []).length;
        if (currentStep >= n - 1) scrollToLineup(); else showStep(currentStep + 1);
      });
    }

    function showStep(i) {
      var els = stepEls(), n = els.length;
      if (n === 0) return;
      if (i < 0) i = 0;
      if (i > n - 1) i = n - 1;
      currentStep = i;
      if (i > maxStep) maxStep = i;
      Array.prototype.forEach.call(els, function (el, idx) {
        if (idx === i) {
          el.style.display = '';
          el.classList.remove('is-anim'); void el.offsetWidth; el.classList.add('is-anim');
        } else {
          el.style.display = 'none';
        }
      });
      updateNav();
      renderChips();
    }

    function updateNav() {
      if (!navEl) return;
      var n = (config.steps || []).length;
      navEl.querySelector('[data-progress]').textContent =
        T.progress.replace('[current]', currentStep + 1).replace('[total]', n);
      navEl.querySelector('[data-back]').style.visibility = currentStep === 0 ? 'hidden' : 'visible';
      navEl.querySelector('[data-next]').innerHTML = currentStep >= n - 1 ? esc(T.review) + ' &darr;' : esc(T.next) + ' &rarr;';
    }

    function advance() {
      var n = (config.steps || []).length;
      if (currentStep >= n - 1) { scrollToLineup(); return; } /* last step done → show the build */
      var target = (currentStep < maxStep) ? maxStep : currentStep + 1; /* re-edit returns to frontier */
      if (target > n - 1) target = n - 1;
      showStep(target);
    }

    function scrollToBar() {
      var bar = root.querySelector('[data-cfg-bar]');
      if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* bring the chosen "your build" lineup into view (mobile: the list below the steps) */
    function scrollToLineup() {
      var mobile = window.matchMedia('(max-width: 990px)').matches;
      var target = (mobile && root.querySelector('[data-cfg-spec-mobile]')) || specEl || root.querySelector('.bastuk-cfg__stage');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      Array.prototype.forEach.call(specEls, function (c) {
        c.classList.remove('is-flash'); void c.offsetWidth; c.classList.add('is-flash');
      });
    }

    function chosenText(step, sel) {
      var none = root.dataset.tNone || 'Inget';
      var placeholder = root.dataset.tChoose || 'Välj…';
      if (!sel) return placeholder;
      if (sel.multi) return sel.options.length ? sel.options.map(function (o) { return o.label; }).join(', ') : none;
      return sel.option ? sel.option.label : placeholder;
    }

    /* the "your build" list — every reached step, clickable to re-open.
       Rendered into both the desktop (under photo) and mobile (below steps) lists. */
    function renderChips() {
      Array.prototype.forEach.call(specEls, function (container) {
        container.innerHTML = '';
        (config.steps || []).forEach(function (step, idx) {
          if (idx > maxStep) return;
          var sel = state[step.id];
          var done = !!(sel && (sel.option || (sel.options && sel.options.length)));
          var li = document.createElement('li');
          li.className = 'bastuk-cfg__navchip' +
            (idx === currentStep ? ' is-current' : '') + (done ? ' is-done' : '');
          li.innerHTML =
            '<span class="bastuk-cfg__navchip-k">' + esc(step.label) + '</span>' +
            '<span class="bastuk-cfg__navchip-v">' + esc(chosenText(step, sel)) + '</span>';
          li.addEventListener('click', function () { showStep(idx); });
          container.appendChild(li);
        });
      });
    }

    function validate() {
      var ok = (config.steps || []).every(function (step) {
        if (!step.required || step.type === 'multi') return true;
        return !!state[step.id];
      });
      addBtn.disabled = !ok;
    }

    /* ---------- hero swap ---------- */
    var heroTimer;
    function swapHero(src, instant) {
      if (!heroEl || !src) return;
      src = resolveAsset(src);
      if (instant) { heroEl.src = src; return; }
      visualEl.classList.add('is-swapping');
      clearTimeout(heroTimer);
      heroTimer = setTimeout(function () {
        heroEl.src = src;
        heroEl.onload = function () { visualEl.classList.remove('is-swapping'); };
      }, 220);
    }

    /* ---------- thumbnails ---------- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-cfg-thumb]'), function (t) {
      t.addEventListener('click', function () {
        Array.prototype.forEach.call(root.querySelectorAll('[data-cfg-thumb]'), function (x) {
          x.classList.remove('is-active');
        });
        t.classList.add('is-active');
        swapHero(t.dataset.img);
      });
    });

    /* ---------- build cart payload ---------- */
    function buildItems() {
      var items = [];
      var props = {};
      var variantStep = baseVariantStep();
      (config.steps || []).forEach(function (step) {
        var sel = state[step.id];
        if (!sel) return;
        /* the variant step is already the line item's own variant option, so
           adding it as a property printed it twice in the cart */
        if (variantStep && step.id === variantStep.id) return;
        if (sel.multi) {
          if (sel.options.length) props[step.label] = sel.options.map(function (o) { return o.label; }).join(', ');
        } else if (sel.option) {
          props[step.label] = sel.option.label;
        }
      });

      /* base product line item */
      items.push({ id: resolveVariantId(), quantity: 1, properties: props });

      /* paid add-on line items, resolved by SKU from the add-on collection */
      var unresolved = [];
      (config.steps || []).forEach(function (step) {
        var sel = state[step.id];
        if (!sel || step.type === 'variant') return;
        var chosen = sel.multi ? sel.options : (sel.option ? [sel.option] : []);
        chosen.forEach(function (o) {
          if (!o.sku || !(+o.price > 0)) return;
          var addon = addonMap[o.sku];
          var expectedCents = Math.round((+o.price || 0) * 100);
          var priceMatches = addon && addon.id && Math.abs((+addon.price || 0) - expectedCents) <= 1;
          if (priceMatches) {
            var addonProps = { _For: root.dataset.productTitle };
            addonProps[root.dataset.tOptionProperty || 'Tillval'] = o.label;
            items.push({
              id: addon.id,
              quantity: o.qty || 1,
              properties: addonProps
            });
          } else {
            /* Never charge the wrong amount. Missing or mismatched add-ons go to quote. */
            unresolved.push(o.label);
          }
        });
      });
      return { items: items, unresolved: unresolved };
    }

    /* ---------- add to cart ---------- */
    var ADD = {
      idle: root.dataset.tAdd || 'Lägg i varukorgen',
      busy: root.dataset.tAdding || 'Lägger till…',
      done: root.dataset.tAdded || 'Tillagd ✓',
      ok: root.dataset.tAddedToast || 'Konfigurationen har lagts i varukorgen',
      err: root.dataset.tAddError || 'Det gick inte att lägga till produkten. Försök igen.',
      quoteFallback: root.dataset.tQuoteFallback || 'Ett eller flera tillval behöver bekräftas. Offertformuläret öppnas.'
    };
    addBtn.addEventListener('click', function () {
      var payload = buildItems();
      if (payload.unresolved.length) {
        /* an add-on product/SKU isn't wired up — fall back to a quote so nothing is mischarged */
        toast(ADD.quoteFallback);
        openQuote(payload.unresolved);
        return;
      }
      addBtn.classList.add('is-busy');
      addLabel.textContent = ADD.busy;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: payload.items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        addLabel.textContent = ADD.done;
        toast(ADD.ok);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        try {
          if (window.routes || true) {
            var bubble = document.querySelector('#cart-icon-bubble');
            /* let Dawn's cart drawer pick it up; otherwise go to cart */
            if (!document.querySelector('cart-drawer')) {
              window.location.href = root.dataset.cartUrl || '/cart';
            } else {
              fetchDrawer();
            }
          }
        } catch (e) {}
        setTimeout(function () {
          addBtn.classList.remove('is-busy');
          addLabel.textContent = ADD.idle;
        }, 2200);
      }).catch(function () {
        addBtn.classList.remove('is-busy');
        addLabel.textContent = ADD.idle;
        toast(ADD.err);
      });
    });

    function fetchDrawer() {
      var drawer = document.querySelector('cart-drawer');
      fetch(root.dataset.cartUrl + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          try {
            var html = new DOMParser().parseFromString(txt, 'text/html');
            var nw = html.querySelector('cart-drawer');
            if (nw && drawer) { drawer.innerHTML = nw.innerHTML; drawer.classList.add('animate', 'active'); }
          } catch (e) {}
        });
    }

    /* ---------- quote ---------- */
    var modal = $('[data-cfg-modal]');
    function openQuote(unresolved) {
      var lines = [];
      (config.steps || []).forEach(function (step) {
        var sel = state[step.id];
        if (!sel) return;
        if (sel.multi && sel.options.length) lines.push(step.label + ': ' + sel.options.map(function (o) { return o.label; }).join(', '));
        else if (sel.option) lines.push(step.label + ': ' + sel.option.label);
      });
      var specText = lines.join('\n');
      $('[data-cfg-form-product]').value = root.dataset.productTitle;
      $('[data-cfg-form-spec]').value = specText;
      $('[data-cfg-form-total]').value = totalEl.textContent;
      var totalLabel = root.dataset.tIndicativeTotal || 'Indikativt totalpris';
      $('[data-cfg-form-summary]').textContent = root.dataset.productTitle + '\n' + specText + '\n' + totalLabel + ': ' + totalEl.textContent;
      modal.hidden = false;
    }
    if (quoteBtn) quoteBtn.addEventListener('click', function () { openQuote([]); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-cfg-modal-close]'), function (b) {
      b.addEventListener('click', function () { modal.hidden = true; });
    });

    /* ---------- toast ---------- */
    var toastEl;
    function toast(msg) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'bastuk-cfg__toast';
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      requestAnimationFrame(function () { toastEl.classList.add('is-shown'); });
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toastEl.classList.remove('is-shown'); }, 2600);
    }

    /* ---------- utils ---------- */
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function cssEsc(s) { return String(s).replace(/"/g, '\\"'); }

    /* ---------- steam & sparks FX ---------- */
    var fxCanvas = root.querySelector('[data-cfg-fx]');
    var fx = setupFx(fxCanvas);

    function setupFx(canvas) {
      if (!canvas || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return { burst: function () {} };
      }
      var ctx, W = 0, H = 0, dpr = 1, steam = [], sparks = [], flames = [], sprites = [], running = false, raf = 0;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      window.addEventListener('resize', function () { isMobile = window.matchMedia('(max-width: 749px)').matches; });

      for (var s = 0; s < 4; s++) {
        var sz = 96, c = document.createElement('canvas'); c.width = c.height = sz;
        var g = c.getContext('2d');
        for (var j = 0; j < 4; j++) {
          var ox = sz / 2 + (Math.random() - 0.5) * sz * 0.25,
              oy = sz / 2 + (Math.random() - 0.5) * sz * 0.25,
              rr = sz * (0.28 + Math.random() * 0.16);
          var gr = g.createRadialGradient(ox, oy, 0, ox, oy, rr);
          gr.addColorStop(0, 'rgba(240,235,224,0.5)');
          gr.addColorStop(0.6, 'rgba(220,212,196,0.16)');
          gr.addColorStop(1, 'rgba(220,212,196,0)');
          g.fillStyle = gr; g.beginPath(); g.arc(ox, oy, rr, 0, 6.283); g.fill();
        }
        sprites.push(c);
      }

      function fit() {
        var r = canvas.getBoundingClientRect();
        dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        W = r.width; H = r.height;
        canvas.width = Math.max(1, Math.round(W * dpr));
        canvas.height = Math.max(1, Math.round(H * dpr));
        ctx = canvas.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      fit();
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(canvas);

      function ambient() {
        steam.push({
          x: Math.random() * W, y: H + 12,
          r: 18 + Math.random() * 32, vy: -(0.15 + Math.random() * 0.3),
          vx: (Math.random() - 0.5) * 0.3, t: 0, life: 320 + Math.random() * 260,
          gw: 1.004 + Math.random() * 0.003, bA: 0.05 + Math.random() * 0.06,
          ph: Math.random() * 6.28, sp: sprites[(Math.random() * sprites.length) | 0]
        });
      }
      function burst(x, y) {
        /* a puff of flame licking upward */
        var flameN = isMobile ? 5 : 9;
        for (var f = 0; f < flameN; f++) flames.push({
          x: x + (Math.random() - 0.5) * 22, y: y + (Math.random() - 0.5) * 8,
          r: 9 + Math.random() * 14, vy: -(0.9 + Math.random() * 1.5),
          vx: (Math.random() - 0.5) * 0.9, t: 0, life: 22 + Math.random() * 22,
          gw: 0.965 + Math.random() * 0.02
        });
        /* sparks — a few more than before */
        var sparkN = isMobile ? 16 : 26;
        for (var k = 0; k < sparkN; k++) {
          var a = Math.random() * 6.28, sp2 = 1.2 + Math.random() * 4;
          sparks.push({
            x: x, y: y, vx: Math.cos(a) * sp2, vy: Math.sin(a) * sp2 - 2,
            t: 0, life: 34 + Math.random() * 32, r: 0.8 + Math.random() * 1.8,
            c: Math.random() < 0.5 ? '201,162,39' : '212,168,37'
          });
        }
        start();
      }
      function frame() {
        ctx.clearRect(0, 0, W, H);
        /* gentle ambient steam from the bottom — disabled on mobile */
        if (!isMobile) {
          if (steam.length < 64 && Math.random() < 0.4) ambient();
          for (var i = steam.length - 1; i >= 0; i--) {
            var p = steam[i]; p.t++;
            p.x += p.vx + Math.sin(p.t * 0.02 + p.ph) * 0.3; p.y += p.vy; p.r *= p.gw;
            var u = p.t / p.life, a = p.bA * (u < 0.2 ? u / 0.2 : (u > 0.7 ? (1 - u) / 0.3 : 1));
            if (a > 0.003) { ctx.globalAlpha = a; ctx.drawImage(p.sp, p.x - p.r, p.y - p.r, p.r * 2, p.r * 2); }
            if (p.t > p.life || p.y < -p.r) steam.splice(i, 1);
          }
        } else if (steam.length) { steam.length = 0; }

        /* flames + sparks use additive blending for glow */
        ctx.globalCompositeOperation = 'lighter';
        for (var fi = flames.length - 1; fi >= 0; fi--) {
          var fl = flames[fi]; fl.t++; fl.x += fl.vx; fl.y += fl.vy; fl.vy *= 0.97; fl.r *= fl.gw;
          var fu = fl.t / fl.life, fa = (1 - fu) * 0.8;
          if (fa > 0 && fl.r > 0.5) {
            var fg = ctx.createRadialGradient(fl.x, fl.y, 0, fl.x, fl.y, fl.r);
            fg.addColorStop(0, 'rgba(255,226,150,' + (fa) + ')');
            fg.addColorStop(0.45, 'rgba(232,140,40,' + (fa * 0.8) + ')');
            fg.addColorStop(1, 'rgba(196,40,10,0)');
            ctx.fillStyle = fg; ctx.beginPath(); ctx.arc(fl.x, fl.y, fl.r, 0, 6.283); ctx.fill();
          }
          if (fl.t > fl.life || fl.r < 0.5) flames.splice(fi, 1);
        }
        for (var s2 = sparks.length - 1; s2 >= 0; s2--) {
          var q = sparks[s2]; q.t++; q.vy += 0.09; q.x += q.vx; q.y += q.vy;
          var qa = 1 - q.t / q.life;
          if (qa > 0) {
            ctx.globalAlpha = qa; ctx.fillStyle = 'rgba(' + q.c + ',1)';
            ctx.beginPath(); ctx.arc(q.x, q.y, q.r, 0, 6.283); ctx.fill();
            ctx.globalAlpha = qa * 0.4; ctx.beginPath(); ctx.arc(q.x, q.y, q.r * 2.6, 0, 6.283); ctx.fill();
          }
          if (q.t > q.life) sparks.splice(s2, 1);
        }
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1;
        if (running) raf = requestAnimationFrame(frame);
      }
      function start() { if (!running) { running = true; raf = requestAnimationFrame(frame); } }
      function stop() { running = false; if (raf) cancelAnimationFrame(raf); }

      /* run only while the section is on screen */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) start(); else stop();
        }, { threshold: 0 }).observe(canvas);
      } else { start(); }

      return { burst: burst };
    }

    render();
    preselect();
    buildNav();
    recalc();
    showStep(0);
    if (modelActive) setupModel();
  }

  /* ---------- built-in demo fallback ---------- */
  function buildDemoConfig() {
    return {
      base_price: 0,
      steps: [
        { id: 'wood', label: 'Material', type: 'variant', required: true, options: [
          { id: 'spruce', label: 'Gran', price: 0, swatch: '#caa472', default: true },
          { id: 'thermo', label: 'Thermowood', price: 1300, swatch: '#5a3a1d' }
        ]},
        { id: 'heater', label: 'Bastuaggregat', type: 'radio', required: true, options: [
          { id: 'none', label: 'Utan aggregat', price: 0, default: true },
          { id: 'h1', label: 'Harvia M3 + isolerad skorsten', price: 2000, desc: 'Vedeldat, inklusive bastustenar' }
        ]},
        { id: 'paint', label: 'Utvändig ytbehandling', type: 'radio', layout: 'grid', options: [
          { id: 'teak', label: 'Teak', price: 0, swatch: '#b07a3c', default: true },
          { id: 'grey', label: 'Transparent grå', price: 0, swatch: '#8d8a85' }
        ]}
      ]
    };
  }

  function boot() {
    document.querySelectorAll('.bastuk-cfg').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  /* Shopify theme editor: the editor re-injects this script on every section
     re-render, so guard the listener globally — otherwise each re-render adds
     another listener and each one re-inits the section (duplicate navs etc.) */
  if (!window.__bastukCfgEditorWired) {
    window.__bastukCfgEditorWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.bastuk-cfg');
      if (el) { delete el.dataset.cfgReady; init(el); }
    });
  }
})();